<template>
  <div class="stackBar w-100">
    <div v-for="(data, device_name) in stacksData" :key="device_name">
      <div class="row mx-0">
        <div class="col-12 px-0">
          <div class="px-0">
            <div
              class="progress"
              :style="{
                height:
                  stacksSize == 'small'
                    ? '1.2rem'
                    : stacksSize == 'midle'
                    ? '2.2rem'
                    : stacksSize == 'package-small'
                    ? '1.2rem'
                    : stacksSize == 'package-midle'
                    ? '2.2rem'
                    : stacksSize == 'package-normal'
                    ? '3rem'
                    : '3rem',
              }"
            >
              <div
                v-for="(item, key) in data"
                :key="key"
                class="progress-bar"
                :class="{
                  'progress-bar-danger': item.status == '警報',
                  'progress-bar-success': item.status == '生產',
                  'progress-bar-len-short': item.status == '短寸',
                  'progress-bar-maintain': item.status == '維修',
                  'progress-bar-shunting': item.status == '調車',
                  'progress-bar-warning': item.status == '待機',
                  'progress-bar-secondary': item.status == '關機',
                  'progress-bar-nodata': item.status == null,
                }"
                role="progressbar"
                :style="{
                  width: (item.duration_number / stacksBarMaxValue) * 100 + '%',
                }"
                :aria-valuenow="item.duration_number"
                aria-valuemin="0"
                :aria-valuemax="stacksBarMaxValue"
                data-bs-toggle="tooltip"
                data-bs-placement="bottom"
                :data-bs-custom-class="
                  'tooltip-bg-' +
                  (item.status == '警報'
                    ? 'danger'
                    : item.status == '生產'
                    ? 'success'
                    : item.status == '短寸'
                    ? 'len-short'
                    : item.status == '維修'
                    ? 'maintain'
                    : item.status == '調車'
                    ? 'shunting'
                    : item.status == '待機'
                    ? 'warning'
                    : item.status == '關機'
                    ? 'secondary'
                    : 'nodata')
                "
                :id="'tooltop-' + device_name + '-' + key"
                :data-bs-title="
                  item.status != null
                    ? item.status == '待機' && item.alarmDetail != ''
                      ? `狀態:${item.status}\n待機原因:${item.alarmDetail}\n開始時間:${item.startTime}\n結束時間:${item.endTime}`
                      : `狀態:${item.status}\n開始時間:${item.startTime}\n結束時間:${item.endTime}`
                    : 'no data'
                "
              ></div>
            </div>
          </div>
          <div
            class="d-flex justify-content-between"
            :style="{
              'font-size':
                stacksSize == 'small'
                  ? '12px'
                  : stacksSize == 'midle'
                  ? '12px'
                  : stacksSize == 'package-small'
                  ? '12px'
                  : stacksSize == 'package-midle'
                  ? '12px'
                  : stacksSize == 'package-normal'
                  ? '18px'
                  : '18px',
            }"
          >
            <template v-if="data[0] != undefined">
              <template v-if="stacksSize == 'normal'">
                <div
                  v-for="(item, key) in stacksBarNumber_default"
                  :class="stacksBarClass[key]"
                  :key="key"
                >
                  {{ item }}
                </div>
              </template>
              <template v-else-if="stacksSize == 'midle'">
                <div
                  v-for="(item, key) in stacksBarNumber_default"
                  :class="stacksBarClass[key]"
                  :key="key"
                  :style="{
                    display:
                      stacksBarClass[key] == 'stacked-bar-time-24'
                        ? 'none'
                        : '',
                  }"
                >
                  {{ item }}
                </div>
              </template>
              <template v-else-if="stacksSize == 'small'">
                <div
                  v-for="(item, key) in stacksBarNumber_default"
                  :class="stacksBarClass[key]"
                  :key="key"
                  :style="{
                    display:
                      stacksBarClass[key] == 'stacked-bar-time-24'
                        ? 'none'
                        : '',
                  }"
                >
                  {{ item }}
                </div>
              </template>
              <template v-else-if="stacksSize == 'package-small'">
                <div
                  v-for="(item, key) in stacksBarNumber_package_default"
                  :class="stacksBarClass_package_default[key]"
                  :key="key"
                >
                  {{ item }}
                </div>
              </template>
              <template v-else-if="stacksSize == 'package-midle'">
                <div
                  v-for="(item, key) in stacksBarNumber_package_default"
                  :class="stacksBarClass_package_default[key]"
                  :key="key"
                >
                  {{ item }}
                </div>
              </template>
              <template v-else-if="stacksSize == 'package-normal'">
                <div
                  v-for="(item, key) in stacksBarNumber_package_default"
                  :class="stacksBarClass_package_default[key]"
                  :key="key"
                >
                  {{ item }}
                </div>
              </template>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Tooltip } from "bootstrap";
import { onMounted, ref, watch } from "@vue/runtime-core";
export default {
  props: {
    stacksBarClass: Array,
    stacksBarMaxValue: Number,
    stacksData: Object,
    stacksSize: String,
  },
  setup(props) {
    const tooltipArray = ref([]);
    onMounted(() => {
      let deviceNameArray = Object.keys(props.stacksData);
      let deviceName = deviceNameArray[0];
      if (deviceName == "-") {
        return;
      }
      props.stacksData[deviceName].forEach((data, index) => {
        tooltipArray.value.push(
          new Tooltip(
            document.getElementById("tooltop-" + deviceName + "-" + index)
          )
        );
      });
    });
    watch(
      () => props.stacksData,
      (newValue) => {
        let deviceNameArray = Object.keys(newValue);
        let deviceName = deviceNameArray[0];
        if (deviceName == "-") {
          return;
        }

        setTimeout(() => {
          newValue[deviceName].forEach((data, index) => {
            if (tooltipArray.value[index] == undefined) {
              tooltipArray.value.push(
                new Tooltip(
                  document.getElementById("tooltop-" + deviceName + "-" + index)
                )
              );
            }
            tooltipArray.value[index]._config.title =
              data.status != null
                ? data.status == "待機" && data.alarmDetail != ""
                  ? `狀態:${data.status}\n待機原因:${data.alarmDetail}\n開始時間:${data.startTime}\n結束時間:${data.endTime}`
                  : `狀態:${data.status}\n開始時間:${data.startTime}\n結束時間:${data.endTime}`
                : "no data";
          });
        }, 0);
      }
    );

    const stacksBarNumber_default = [
      "08",
      "09",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "19",
      "20",
      "21",
      "22",
      "23",
      "00",
      "01",
      "02",
      "03",
      "04",
      "05",
      "06",
      "07",
      "08",
    ];
    const stacksBarNumber_package_default = [
      "08",
      "09",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "19",
      "20",
    ];
    const stacksBarClass_package_default = [
      "stacked-bar-time",
      "stacked-bar-time-12",
      "stacked-bar-time-12",
      "stacked-bar-time-6",
      "stacked-bar-time-12",
      "stacked-bar-time-12",
      "stacked-bar-time-3",
      "stacked-bar-time-12",
      "stacked-bar-time-12",
      " stacked-bar-time-6",
      "stacked-bar-time-12",
      "stacked-bar-time-12",
      "stacked-bar-time",
    ];
    return {
      stacksBarNumber_default,
      stacksBarNumber_package_default,
      stacksBarClass_package_default,
      // tooltipKey,
    };
  },
};
</script>

<style>
@media (max-width: 1350px) {
  .stacked-bar-time-24 {
    display: none;
  }
}
@media (max-width: 950px) {
  .stacked-bar-time-12 {
    display: none;
  }
}
@media (max-width: 650px) {
  .stacked-bar-time-12.stacked-bar-time-6 {
    display: block;
  }
  .stacked-bar-time-6 {
    display: none;
  }
}
@media (max-width: 350px) {
  .stacked-bar-time-12.stacked-bar-time-6 {
    display: none;
  }
}
@media (max-width: 200px) {
  .stacked-bar-time-3 {
    display: none;
  }
}
.progress-bar-danger {
  background-color: var(--main-status-danger-color);
}
.progress-bar-success {
  background-color: var(--main-status-success-color);
}
.progress-bar-len-short {
  background-color: #99f98c;
}
.progress-bar-maintain {
  background-color: var(--main-status-maintain-color);
}
.progress-bar-shunting {
  background-color: var(--main-status-shunting-color);
}
.progress-bar-warning {
  background-color: var(--main-status-warning-color);
}
.progress-bar-secondary {
  background-color: var(--main-status-secondary-color);
}
.progress-bar-nodata {
  background-color: var(--main-status-nodata-color);
}
.progress-bar-danger:hover {
  background-color: var(--main-status-danger-color);
}
.progress-bar-success:hover {
  background-color: #218838;
}
.progress-bar-len-short:hover {
  background-color: #77c46d;
}
.progress-bar-maintain:hover {
  background-color: #a9abf8;
}
.progress-bar-shunting:hover {
  background-color: #1199d8;
}
.progress-bar-warning:hover {
  background-color: #e0a800;
}
.progress-bar-secondary:hover {
  background-color: #5a6268;
}

.tooltip-inner {
  max-width: none;
  /* box-shadow: 0px 0px 4px black; */
  opacity: 1 !important;
  white-space: pre-line;
  font-family: "dfyuanstd-w7";
}

.tooltip-bg-danger .tooltip-inner {
  color: var(--main-font-color);
  background-color: #dc3545;
}
.tooltip-bg-danger.tooltip.bs-tooltip-right .tooltip-arrow::before {
  border-right-color: #dc3545 !important;
}
.tooltip-bg-danger.tooltip.bs-tooltip-left .tooltip-arrow::before {
  border-left-color: #dc3545 !important;
}
.tooltip-bg-danger.tooltip.bs-tooltip-bottom .tooltip-arrow::before {
  border-bottom-color: #dc3545 !important;
}
.tooltip-bg-danger.tooltip.bs-tooltip-top .tooltip-arrow::before {
  border-top-color: #dc3545 !important;
}
.tooltip-bg-success .tooltip-inner {
  color: var(--main-font-color);
  background-color: #28a745;
}
.tooltip-bg-success.tooltip.bs-tooltip-right .tooltip-arrow::before {
  border-right-color: #28a745 !important;
}
.tooltip-bg-success.tooltip.bs-tooltip-left .tooltip-arrow::before {
  border-left-color: #28a745 !important;
}
.tooltip-bg-success.tooltip.bs-tooltip-bottom .tooltip-arrow::before {
  border-bottom-color: #28a745 !important;
}
.tooltip-bg-success.tooltip.bs-tooltip-top .tooltip-arrow::before {
  border-top-color: #28a745 !important;
}
.tooltip-bg-len-short .tooltip-inner {
  color: var(--main-font-color);
  background-color: #28a745;
}
.tooltip-bg-len-short.tooltip.bs-tooltip-right .tooltip-arrow::before {
  border-right-color: #28a745 !important;
}
.tooltip-bg-len-short.tooltip.bs-tooltip-left .tooltip-arrow::before {
  border-left-color: #28a745 !important;
}
.tooltip-bg-len-short.tooltip.bs-tooltip-bottom .tooltip-arrow::before {
  border-bottom-color: #28a745 !important;
}
.tooltip-bg-len-short.tooltip.bs-tooltip-top .tooltip-arrow::before {
  border-top-color: #28a745 !important;
}
.tooltip-bg-maintain .tooltip-inner {
  color: var(--main-font-color);
  background-color: #6f42c1;
}
.tooltip-bg-maintain.tooltip.bs-tooltip-right .tooltip-arrow::before {
  border-right-color: #6f42c1 !important;
}
.tooltip-bg-maintain.tooltip.bs-tooltip-left .tooltip-arrow::before {
  border-left-color: #6f42c1 !important;
}
.tooltip-bg-maintain.tooltip.bs-tooltip-bottom .tooltip-arrow::before {
  border-bottom-color: #6f42c1 !important;
}
.tooltip-bg-maintain.tooltip.bs-tooltip-top .tooltip-arrow::before {
  border-top-color: #6f42c1 !important;
}
.tooltip-bg-shunting .tooltip-inner {
  color: var(--main-font-color);
  background-color: #007bff;
}
.tooltip-bg-shunting.tooltip.bs-tooltip-right .tooltip-arrow::before {
  border-right-color: #007bff !important;
}
.tooltip-bg-shunting.tooltip.bs-tooltip-left .tooltip-arrow::before {
  border-left-color: #007bff !important;
}
.tooltip-bg-shunting.tooltip.bs-tooltip-bottom .tooltip-arrow::before {
  border-bottom-color: #007bff !important;
}
.tooltip-bg-shunting.tooltip.bs-tooltip-top .tooltip-arrow::before {
  border-top-color: #007bff !important;
}
.tooltip-bg-warning .tooltip-inner {
  color: #212529;
  background-color: #ffc107;
}
.tooltip-bg-warning.tooltip.bs-tooltip-right .tooltip-arrow::before {
  border-right-color: #ffc107 !important;
}
.tooltip-bg-warning.tooltip.bs-tooltip-left .tooltip-arrow::before {
  border-left-color: #ffc107 !important;
}
.tooltip-bg-warning.tooltip.bs-tooltip-bottom .tooltip-arrow::before {
  border-bottom-color: #ffc107 !important;
}
.tooltip-bg-warning.tooltip.bs-tooltip-top .tooltip-arrow::before {
  border-top-color: #ffc107 !important;
}
.tooltip-bg-secondary .tooltip-inner {
  color: var(--main-font-color);
  background-color: var(--main-status-secondary-color);
}
.tooltip-bg-secondary.tooltip.bs-tooltip-right .tooltip-arrow::before {
  border-right-color: var(--main-status-secondary-color) !important;
}
.tooltip-bg-secondary.tooltip.bs-tooltip-left .tooltip-arrow::before {
  border-left-color: var(--main-status-secondary-color) !important;
}
.tooltip-bg-secondary.tooltip.bs-tooltip-bottom .tooltip-arrow::before {
  border-bottom-color: var(--main-status-secondary-color) !important;
}
.tooltip-bg-secondary.tooltip.bs-tooltip-top .tooltip-arrow::before {
  border-top-color: var(--main-status-secondary-color) !important;
}
.tooltip-bg-nodata .tooltip-inner {
  color: var(--main-font-color);
  background-color: #343a40;
}
.tooltip-bg-nodata.tooltip.bs-tooltip-right .tooltip-arrow::before {
  border-right-color: #343a40 !important;
}
.tooltip-bg-nodata.tooltip.bs-tooltip-left .tooltip-arrow::before {
  border-left-color: #343a40 !important;
}
.tooltip-bg-nodata.tooltip.bs-tooltip-bottom .tooltip-arrow::before {
  border-bottom-color: #343a40 !important;
}
.tooltip-bg-nodata.tooltip.bs-tooltip-top .tooltip-arrow::before {
  border-top-color: #343a40 !important;
}
</style>
